import { toastController } from '@ionic/vue';
import {checkmarkCircleOutline, closeOutline} from "ionicons/icons";

export function useToast() {
  const showToast = async (message: string, type: 'error' | 'success'   = 'success'  ) => {
    const toast = await toastController.create({
      message: message,
      duration: 2500,
      position: 'bottom',
      mode: 'ios',
      icon: type == 'success' ? checkmarkCircleOutline : closeOutline,
      cssClass: type == 'success' ? 'toast-success' : 'toast-error',
    });
    await toast.present();
  };

  return {
    showToast,
  };
}
